<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.9194 24.9946C28.9194 25.6175 29.1669 26.2149 29.6073 26.6554C30.0478 27.0958 30.6452 27.3433 31.2681 27.3433C31.891 27.3433 32.4883 27.0958 32.9288 26.6554C33.3693 26.2149 33.6167 25.6175 33.6167 24.9946C33.6167 24.3717 33.3693 23.7743 32.9288 23.3339C32.4883 22.8934 31.891 22.646 31.2681 22.646C30.6452 22.646 30.0478 22.8934 29.6073 23.3339C29.1669 23.7743 28.9194 24.3717 28.9194 24.9946Z"
      fill="currentColor"
    />
    <path
      d="M24.9673 3.14404C12.8872 3.14404 3.09229 12.939 3.09229 25.019C3.09229 37.0991 12.8872 46.894 24.9673 46.894C37.0474 46.894 46.8423 37.0991 46.8423 25.019C46.8423 12.939 37.0474 3.14404 24.9673 3.14404ZM23.9565 29.8237C23.9565 30.6138 23.4805 31.3257 22.751 31.6284C22.5142 31.7267 22.2603 31.7773 22.0039 31.7773C21.4956 31.7773 20.9961 31.5791 20.6226 31.2051L14.4556 25.0381V29.686C14.4556 30.7646 13.5811 31.6392 12.5024 31.6392C11.4238 31.6392 10.5493 30.7646 10.5493 29.686V20.3228C10.5493 19.5327 11.0254 18.8208 11.7549 18.5181C12.1118 18.3702 12.5044 18.3316 12.8833 18.4069C13.2622 18.4823 13.6102 18.6683 13.8833 18.9414L20.0498 25.1079V20.3223C20.0498 19.2437 20.9243 18.3691 22.0029 18.3691C23.0815 18.3691 23.9561 19.2437 23.9561 20.3223V29.8237H23.9565ZM31.2681 31.25C27.8135 31.25 25.0132 28.4497 25.0132 24.9951C25.0132 21.5405 27.8135 18.7397 31.2681 18.7397C34.7227 18.7397 37.5229 21.54 37.5229 24.9951C37.5229 28.4502 34.7227 31.25 31.2681 31.25ZM39.0459 31.248C38.1768 31.248 37.4727 30.5435 37.4727 29.6748C37.4727 28.8062 38.1772 28.1016 39.0459 28.1016C39.9145 28.1016 40.6191 28.8062 40.6191 29.6748C40.6191 30.5435 39.9145 31.248 39.0459 31.248Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'CallNum',
} as DefineComponent
</script>
